<template>
  <b-modal
    :visible="visible"
    centered
    hide-header
    hide-footer
    scrollable
    dialog-class="modal-color-black delete-persons-dialog"
    @hide="onDialogHide"
  >
    <div class="delete-persons-header">
      <h3>{{ $t('Delete contacts') }}</h3>
    </div>

    <div class="delete-persons-row">
      {{
        $t('Are you sure you want to delete {count} contacts? This action cannot be undone!', {
          count: personIds.length,
        })
      }}
    </div>

    <div class="delete-persons-actions">
      <b-spinner v-if="processing" variant="primary" />

      <b-button
        :disabled="processing"
        pill
        size="sm"
        variant="secondary"
        class="text-uppercase btn-text mr-2"
        @click="onCancelClick"
      >
        <span>{{ $t('confirm-cancel') }}</span>
      </b-button>

      <b-button
        :disabled="!hasPermissionsToDelete || processing"
        pill
        size="sm"
        variant="primary"
        class="text-uppercase mx-2"
        @click="onConfirmClick"
      >
        <span>{{ $t('Confirm') }}</span>
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'DeletePersonsDialog',

  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    personIds: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      processing: false,
    };
  },

  computed: {
    ...mapGetters(['getPerson', 'hasSimplePermissions']),

    hasPermissionsToDelete() {
      return this.hasSimplePermissions('deletePerson');
    },
  },

  methods: {
    ...mapActions(['deletePerson']),

    onDialogHide(event) {
      if (this.processing) {
        event.preventDefault();
      } else {
        this.$emit('close');
      }
    },

    async onConfirmClick() {
      if (!this.hasPermissionsToDelete) {
        return;
      }
      this.processing = true;

      for (let i = 0; i < this.personIds.length; i++) {
        const person = this.getPerson(this.personIds[i]);
        await this.deletePerson({ person });
      }

      this.processing = false;
      this.$emit('confirm');
    },

    onCancelClick() {
      if (!this.processing) {
        this.$emit('cancel');
      }
    },
  },
};
</script>

<style>
.delete-persons-dialog .modal-body {
  padding: 32px 52px;
}
</style>

<style scoped>
.delete-persons-header {
  border-bottom: 2px solid var(--bs-gray-500);
}

.delete-persons-actions {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 32px;
}

.delete-persons-row {
  min-height: 42px;
  padding: 8px 0;
  border-bottom: 1px solid var(--bs-gray-500);
}

.delete-persons-actions {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 32px;
}
</style>



// WEBPACK FOOTER //
// src/components/organisation/DeletePersonsDialog.vue